import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-sub pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div>
            <h3 className="text-xl font-bold mb-4 tracking-wider text-primary" style={{ fontFamily: "'Cormorant Garamond', serif" }}>おかやま美容室</h3>
            <p className="text-sm text-white leading-relaxed mb-4">岡山市で愛される美容室。お客様一人ひとりに寄り添った丁寧なカウンセリングと高い技術力で、理想のヘアスタイルを実現します。</p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-white text-xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white text-xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="https://line.me" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-line-fill text-white text-xl w-6 h-6 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4 tracking-wider text-accent" style={{ fontFamily: "'Montserrat', sans-serif" }}>MENU</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-sm text-white hover:text-accent transition-colors whitespace-nowrap">HOME</Link>
              <Link to="/about" className="text-sm text-white hover:text-accent transition-colors whitespace-nowrap">ABOUT</Link>
              <Link to="/information" className="text-sm text-white hover:text-accent transition-colors whitespace-nowrap">INFORMATION</Link>
              <Link to="/recruit" className="text-sm text-white hover:text-accent transition-colors whitespace-nowrap">RECRUIT</Link>
              <Link to="/style" className="text-sm text-white hover:text-accent transition-colors whitespace-nowrap">STYLE</Link>
              <Link to="/contact" className="text-sm text-white hover:text-accent transition-colors whitespace-nowrap">CONTACT</Link>
            </nav>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4 tracking-wider text-accent" style={{ fontFamily: "'Montserrat', sans-serif" }}>CONTACT</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-phone-line text-white mt-1 mr-2 w-5 h-5 flex items-center justify-center"></i>
                <div>
                  <p className="text-sm text-white">TEL: 086-012-3456</p>
                  <p className="text-sm text-white">FAX: 086-012-3457</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line text-white mt-1 mr-2 w-5 h-5 flex items-center justify-center"></i>
                <p className="text-sm text-white">岡山市北区○○町1-2-3</p>
              </div>
              <div className="flex items-start">
                <i className="ri-time-line text-white mt-1 mr-2 w-5 h-5 flex items-center justify-center"></i>
                <div>
                  <p className="text-sm text-white">営業時間: 9:00 - 18:00</p>
                  <p className="text-sm text-white">定休日: 日曜日・祝日</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            &copy; 2024 おかやま美容室株式会社. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
